import React from 'react';
import { Modal, Field } from '../../components/ui';
import { money } from '../../utils/helpers';
import { RATE_TYPES, SERVICE_STATUSES, OTHER_SERVICE_TYPE, isPerUnit } from './useServices';
import '../../styles/money.css';

// Mobile add/edit service — full screen, thumb-sized: the service as big tap
// tiles, owner login / rate type / status as segmented buttons, the money two
// boxes to a row, and the total on the Save button.
export default function ServiceFormMobile({ vm }) {
  const {
    form, setF, editing, saving, save, setOpen, types, functionOptions, userOptions,
    vendorMode, setVendorMode,
  } = vm;
  const perUnit = isPerUnit(form.RateType);
  const unitWord = form.RateType === 'PerPlate' ? 'Plates' : form.RateType === 'PerDay' ? 'Days' : form.RateType === 'PerHour' ? 'Hours' : 'Quantity';
  const total = Number(form.TotalAmount || 0);

  const amount = (label, key) => (
    <label className="field mn-amt">{label}
      <input type="number" inputMode="decimal" value={form[key] ?? ''} onChange={(e) => setF(key, e.target.value)} />
    </label>
  );

  return (
    <Modal
      fullScreen
      title={editing ? `Edit ${editing.ServiceType}` : 'Add Service'}
      onClose={() => setOpen(false)}
      footer={<>
        <button className="btn light" style={{ padding: 12 }} onClick={() => setOpen(false)}>Cancel</button>
        <button className="btn primary" style={{ flex: 1, padding: 12 }} disabled={saving} onClick={save}>
          {saving ? 'Saving...' : total > 0 ? `Save · ${money(total)}` : 'Save'}
        </button>
      </>}
    >
      <div className="mn-sec">Which service?</div>
      <div className="mn-pick">
        {types.map(t => (
          <button key={t.ServiceTypeId} type="button"
            className={String(form.ServiceTypeId) === String(t.ServiceTypeId) ? 'on' : ''}
            onClick={() => setF('ServiceTypeId', String(t.ServiceTypeId))}>{t.ServiceTypeName}</button>
        ))}
        <button type="button" className={'ghost' + (form.ServiceTypeId === OTHER_SERVICE_TYPE ? ' on' : '')}
          onClick={() => setF('ServiceTypeId', OTHER_SERVICE_TYPE)}>+ Other</button>
      </div>
      {form.ServiceTypeId === OTHER_SERVICE_TYPE && (
        <Field label="New service name" value={form.ServiceType} required onChange={(v) => setF('ServiceType', v)} />
      )}

      <Field label="For function" type="select" value={form.FunctionId} options={functionOptions} onChange={(v) => setF('FunctionId', v)} />
      <Field label="Company name" value={form.CompanyName} onChange={(v) => setF('CompanyName', v)} />
      <Field label="Owner / contact person" value={form.ContactName} onChange={(v) => setF('ContactName', v)} />

      <div className="mn-seg-wrap">Owner login
        <div className="mn-seg m">
          <button type="button" className={vendorMode === 'new' ? 'on' : ''} onClick={() => setVendorMode('new')}>By mobile</button>
          <button type="button" className={vendorMode === 'existing' ? 'on' : ''} onClick={() => setVendorMode('existing')}>Existing user</button>
        </div>
      </div>
      {vendorMode === 'existing' ? (
        <Field label="User" type="select" value={form.VendorUserId} options={userOptions} onChange={(v) => setF('VendorUserId', v)} />
      ) : (
        <label className="field">Owner mobile (login, PIN 1234)
          <input type="tel" inputMode="numeric" maxLength={10} value={form.ContactMobile}
            style={{ fontSize: 17, padding: 12, letterSpacing: 1 }} onChange={(e) => setF('ContactMobile', e.target.value)} />
        </label>
      )}

      <div className="mn-sec" style={{ marginTop: 10 }}>Charges</div>
      {form.RateType === 'Lines' ? (
        <div className="muted" style={{ fontSize: 13, marginBottom: 8 }}>
          Itemised ({money(form.TotalAmount)} when last saved) — change them on the service's page.
        </div>
      ) : (<>
      <div className="mn-seg-wrap">Rate type
        <div className="mn-seg m">
          {RATE_TYPES.map(r => (
            <button key={r.value} type="button" className={form.RateType === r.value ? 'on' : ''}
              onClick={() => setF('RateType', r.value)}>{r.label.replace(' amount', '')}</button>
          ))}
        </div>
      </div>
      <div className="mn-pair">
        {amount(perUnit ? 'Rate ₹ / unit' : 'Rate (₹)', 'Rate')}
        {perUnit ? amount(unitWord, 'ConfirmedCount') : amount('Total (₹)', 'TotalAmount')}
      </div>
      {(perUnit || !editing) && (
        <div className="mn-pair">
          {perUnit && amount('Total (₹)', 'TotalAmount')}
          {!editing && amount('Advance now (₹)', 'AdvancePaid')}
        </div>
      )}
      </>)}
      <Field label="Balance due by" type="date" value={form.DueDate} onChange={(v) => setF('DueDate', v)} />

      <div className="mn-sec" style={{ marginTop: 10 }}>When</div>
      <Field label="Date" type="date" required value={form.ServiceDate} onChange={(v) => setF('ServiceDate', v)} />
      <div className="mn-pair">
        <Field label="Start time" type="time" value={form.StartTime} onChange={(v) => setF('StartTime', v)} />
        <Field label="End time" type="time" value={form.EndTime} onChange={(v) => setF('EndTime', v)} />
      </div>
      <div className="mn-seg-wrap">Status
        <div className="mn-seg m">
          {SERVICE_STATUSES.map(s => (
            <button key={s} type="button" className={form.Status === s ? 'on' : ''} onClick={() => setF('Status', s)}>{s}</button>
          ))}
        </div>
      </div>
      <Field label="Notes" type="textarea" rows={2} value={form.Notes} onChange={(v) => setF('Notes', v)} />
    </Modal>
  );
}
